export default {
  SAME_AS_APPLICANT: 'SAME_AS_APPLICANT',
  SAME_AS_MANUFACTURER: 'SAME_AS_MANUFACTURER',
  MANUAL_INPUT: 'MANUAL_INPUT',
  UL_FILE_NUMBER_INPUT: 'UL_FILE_NUMBER_INPUT',
}
